import { useFormik } from "formik";
import React, { useEffect, useState } from "react";
import { XMarkIcon } from "@heroicons/react/20/solid";
import _ from "lodash";
import { useMutation } from "@apollo/client";
import preAuthGQL from "../../../gql/preAuth";
import toast from "react-hot-toast";

import "../styles/pre-auth.css";
import AppModal from "../../../components/AppModal";
import { Divider } from "@mui/material";
import { styled } from "@mui/material/styles";
import CloudUploadIcon from "@mui/icons-material/CloudUpload";
import * as Yup from "yup";
import { useTranslation } from "react-i18next";
import CustomFilterInput from "../../../shared/CustomFilterInput";
import AppButton from "../../../shared/AppButton";

const CommuniModal = ({
  showCommunicationModal,
  setshowCommunicationModal,
  dataArray,
  setdataArray,
  item,
  currentItem,
  communicationId,
  communicationRefetch,
}) => {
  const { t } = useTranslation();
  const [image, setFile] = useState(null);
  const [fileType, setFileType] = useState(null);
  const [commentArray, setcommentArray] = useState([]);
  const [selectEmpty, setselectEmpty] = useState(false);
  const [selectedItem, setselectedItem] = useState(null);

  const [addCommunication, { data, loading, error }] = useMutation(
    preAuthGQL.ADD_COMMUNICATION,
    {
      update(proxy, result) {
        onSuccessfulRequestResponse(result.data);
      },
      onError(error) {
        onResponseError(error.graphQLErrors[0]);
      },
    },
  );

  const onSuccessfulRequestResponse = (data) => {
    if (data?.communicationRequest?.nphies_err) {
      toast.error(data?.communicationRequest?.message);
      data?.communicationRequest?.nphies_err &&
        data?.communicationRequest?.nphies_err.length > 0 &&
        data?.communicationRequest?.nphies_err?.map((err) =>
          toast.error(`${err?.code} - ${err?.display}`),
        );
    } else {
      toast.success(
        data?.communicationRequest?.message || t("Successfully Added!"),
      );
      setshowCommunicationModal(false);
    }
    communicationRefetch({
      input: {
        transaction_id: currentItem?.transaction_id,
        request_name: "preAuth",
      },
    });
    setcommentArray([]);
  };

  const onResponseError = (error) => {
    toast.error(`${error?.message}`);
  };

  const [obj, setobj] = useState({
    payload_attachment: null,
    payload_comment: null,
    item_sequence: null,
  });

  const getCurrentDate = () => {
    const currentDate = new Date();
    const day = String(currentDate.getDate()).padStart(2, "0");
    const month = String(currentDate.getMonth() + 1).padStart(2, "0");
    const year = String(currentDate.getFullYear());
    return `${year}-${month}-${day}`;
  };

  const removeItem = (data, index) => {
    let tempArray = [...commentArray];
    tempArray.splice(index, 1);
    setcommentArray(tempArray);
  };

  const addDataTwo = (e) => {
    e.preventDefault();
    if (obj.payload_attachment === "" && obj.payload_comment === "") {
      setselectEmpty(true);
      return;
    }
    let tempArr = [...commentArray];
    tempArr.push({ ...obj });
    setcommentArray(tempArr);
    setobj({
      payload_attachment: null,
      payload_comment: null,
      item_sequence: null,
    });
    setFile(null);
  };

  const handleChange = (e) => {
    setobj((prev) => ({
      ...prev,
      [e.target.name]: e.target.value,
    }));
  };

  const addToCommunication = () => {
    try {
      if (communicationId) {
        addCommunication({
          variables: {
            input: {
              transaction_id: item?.getPreAuthTransaction?.data?.transaction_id,
              type: "solicited",
              request_name: "preAuth",
              communication_id: communicationId,
              payload: [...commentArray],
            },
          },
        });
      } else {
        addCommunication({
          variables: {
            input: {
              transaction_id: item?.getPreAuthTransaction?.data?.transaction_id,
              type: "unsolicited",
              request_name: "preAuth",
              payload: [...commentArray],
            },
          },
        });
      }
      setcommentArray([]);
      formik.resetForm();
    } catch (error) {
      console.log("The mutation error is ", error.message);
    }
  };

  const VisuallyHiddenInput = styled("input")({
    clip: "rect(0 0 0 0)",
    clipPath: "inset(50%)",
    height: 1,
    overflow: "hidden",
    position: "absolute",
    bottom: 0,
    left: 0,
    whiteSpace: "nowrap",
    width: 1,
  });

  const formik = useFormik({
    initialValues: {
      payload_attachment: null,
      payload_comment: null,
      item_sequence: null,
    },
    validationSchema: Yup.object().shape({
      payload_attachment: Yup.object({
        payload_attachment_content_type: Yup.mixed()
          .nullable()
          .label(t("File Type"))
          .test(
            "fileFormat",
            t("Invalid file format. Please upload a JPG, JPEG, or PDF file."),
            (value) => {
              if (value) {
                return (
                  value === "image/jpeg" ||
                  value === "image/jpg" ||
                  value === "application/pdf"
                );
              }
              return true;
            },
          ),
        payload_attachment_data: Yup.mixed().nullable().label(t("File")),
        payload_attachment_title: Yup.string().nullable(),
        payload_attachment_creation_date: Yup.string().nullable(),
      }).nullable(),
      payload_comment: Yup.string()
        .nullable()
        .test(
          "commentOrAttachment",
          t("Either attachment or comment is required"),
          function (value) {
            const { payload_attachment } = this.parent;
            if (
              !value &&
              (!payload_attachment?.payload_attachment_content_type ||
                !payload_attachment?.payload_attachment_data)
            ) {
              return this.createError({
                path: "payload_comment",
                message: t("Either attachment or comment is required"),
              });
            }
            return true;
          },
        ),
      item_sequence: Yup.number().nullable(),
    }),
    onSubmit: async (values) => {
      let tempArr = [...commentArray];
      tempArr.push({ ...values });
      setcommentArray(tempArr);
      formik.resetForm();
    },
  });

  const onImageChange = (event) => {
    if (event.target.files && event.target.files[0]) {
      const file = event.target.files[0];
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onloadend = () => {
        setFile(URL.createObjectURL(event.target.files[0]));
        setFileType(file.type);
        formik?.setValues((prev) => ({
          ...prev,
          payload_attachment: {
            payload_attachment_content_type: file.type,
            payload_attachment_data: reader.result?.split(",")[1],
            payload_attachment_title: file.name,
            payload_attachment_creation_date: getCurrentDate(),
          },
        }));
      };
    }
  };

  useEffect(() => {
    if (formik?.values?.payload_attachment) {
      formik?.setFieldValue("payload_comment", null);
    }
  }, [formik?.values?.payload_attachment]);

  useEffect(() => {
    if (formik?.values?.item_sequence) {
      formik?.setFieldValue(
        "item_sequence",
        parseInt(formik?.values?.item_sequence),
      );
    }
  }, [formik?.values?.item_sequence]);

  return (
    <div
      className={`${showCommunicationModal ? "open" : ""} modal`}
      id="search-filter"
    >
      <div className="modal-content">
        {/* Header */}
        <div className="flex items-center justify-between border-b border-gray-200 pb-3 mb-3">
          <div className="text-sm font-bold text-[#1e293b] uppercase tracking-wide">
            {communicationId
              ? t("Reply to Communication")
              : t("Add Communication")}
          </div>
          <div
            onClick={() => setshowCommunicationModal(false)}
            className="h-6 w-6 bg-[#0070C2] rounded-full flex items-center justify-center cursor-pointer hover:bg-blue-800 transition-colors shadow-sm"
          >
            <XMarkIcon className="h-4 w-4 text-white" />
          </div>
        </div>

        {/* Body */}
        <div className="flex flex-col gap-2">
          {/* Upload Button */}
          <div className="flex flex-col items-center">
            <AppButton
              component="label"
              startIcon={<CloudUploadIcon />}
              className="!w-full !py-2"
            >
              <span className="truncate max-w-[250px]">
                {formik.values.payload_attachment?.payload_attachment_title ||
                  t("Upload file")}
              </span>
              <input
                type="file"
                hidden
                onChange={onImageChange}
                accept="image/*,application/pdf"
              />
            </AppButton>
            {formik.errors.payload_attachment
              ?.payload_attachment_content_type && (
              <p className="text-[10px] text-red-500 mt-1">
                {
                  formik.errors.payload_attachment
                    .payload_attachment_content_type
                }
              </p>
            )}
          </div>

          {/* OR Divider */}
          {!formik?.values?.payload_attachment && (
            <Divider>
              <span className="text-[10px] text-gray-400 uppercase">
                {t("or")}
              </span>
            </Divider>
          )}

          {/* Investigation Textarea */}
          <div className="flex flex-col gap-1">
            <label className="text-xs font-semibold text-gray-700">
              {t("Investigation")}
            </label>
            <textarea
              name="payload_comment"
              placeholder={t("Enter investigation details here")}
              value={formik.values.payload_comment || ""}
              onChange={formik.handleChange}
              rows={3}
              className="w-full px-3 py-2 text-sm border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent resize-none overflow-hidden"
              style={{
                minHeight: "60px",
                height: "auto",
              }}
              onInput={(e) => {
                e.target.style.height = "auto";
                e.target.style.height = e.target.scrollHeight + "px";
              }}
            />
            {formik.errors.payload_comment && formik.touched.payload_comment && (
              <p className="text-[10px] text-red-500">
                {formik.errors.payload_comment}
              </p>
            )}
          </div>

          {/* Item Sequence Select */}
          <CustomFilterInput
            label={t("Item Sequence")}
            isSelect
            name="item_sequence"
            placeholder={t("Please Select Sequence")}
            value={formik.values.item_sequence}
            onChange={formik.handleChange}
            error={formik.errors.item_sequence}
            touched={formik.touched.item_sequence}
            options={item?.getPreAuthTransaction?.data?.items?.map((itm) => ({
              id: itm.sequence_no,
              name: `${itm.type} - ${itm.standard_code} (${itm.standard_description})`,
            }))}
          />

          {/* Add to List Button */}
          <AppButton
            label={t("Add to List")}
            fullWidth
            onClick={formik.handleSubmit}
            bgColor="#10b981"
          />

          {/* Comment Array List */}
          {commentArray.length > 0 && (
            <div className="mt-1 flex flex-col gap-2">
              {commentArray.map((item, index) => (
                <div
                  key={index}
                  className="flex justify-between items-start bg-blue-50 border border-blue-100 rounded-md px-3 py-2"
                >
                  <div className="flex flex-col gap-1 flex-1">
                    {item?.payload_attachment?.payload_attachment_data ? (
                      <div>
                        {item?.payload_attachment
                          ?.payload_attachment_content_type ===
                        "application/pdf" ? (
                          <span className="text-xs text-gray-700 font-medium">
                            📄{" "}
                            {item?.payload_attachment?.payload_attachment_title}
                          </span>
                        ) : (
                          <img
                            src={
                              "data:image/jpeg;base64," +
                              item.payload_attachment.payload_attachment_data
                            }
                            alt={`${item?.payload_attachment?.payload_attachment_title}`}
                            className="w-12 h-12 rounded-md object-cover"
                          />
                        )}
                      </div>
                    ) : (
                      <div className="flex items-center gap-2">
                        <span className="text-xs font-semibold text-gray-600">
                          {t("Investigation")}:
                        </span>
                        <span className="text-xs text-gray-500">
                          {item?.payload_comment || "-"}
                        </span>
                      </div>
                    )}
                    {item?.item_sequence && (
                      <div className="text-xs text-gray-500">
                        <span className="font-semibold">{t("Seq")}:</span>{" "}
                        {item?.item_sequence}
                      </div>
                    )}
                  </div>
                  <XMarkIcon
                    className="h-4 w-4 text-gray-400 hover:text-red-500 cursor-pointer mt-0.5 ml-2 flex-shrink-0"
                    onClick={() => removeItem(item, index)}
                  />
                </div>
              ))}
            </div>
          )}

          {/* Action Buttons */}
          <div className="flex gap-2 pt-2 border-t border-gray-200">
            <AppButton
              label={
                communicationId ? t("Send Reply") : t("Send Communication")
              }
              fullWidth
              disabled={commentArray.length === 0}
              onClick={addToCommunication}
              isLoading={loading}
            />
            <AppButton
              label={t("Cancel")}
              variant="outlined"
              fullWidth
              bgColor="transparent"
              className="!text-gray-500 !border-gray-300"
              onClick={() => setshowCommunicationModal(false)}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default CommuniModal;
